import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import download from "downloadjs";
import { USER_LOCALSTORAGE_KEY } from "../../../../../../shared/const/localstorage";

export const getPdf = createAsyncThunk(
    "courses/getPdf",
    async (trackingId: string | number, thunkAPI) => {

        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }

            const { token } = JSON.parse(authToken);

            const response = await axios.get(`/api/payments/pdf/${trackingId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                responseType: "blob",
            });

            if (!response.data) {
                throw new Error("Response data is empty");
            }

            download(response.data, "file.pdf", "application/pdf");

            return response.data;
        } catch (error) {
            // Handle the error
            // @ts-ignore
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);
